export default {
  strategyPublic: [
    { name: "Importados", value: "IMPORTED", tableTab: 0, color: "blue" },
    {
      name: "Não verificados",
      value: "UNCHECKED",
      tableTab: 1,
      color: "black",
    },
    { name: "Verificados", value: "CHECKED", tableTab: 2, color: "green" },
    // { name: "Higienizados", value: "SANITIZED", tableTab: 3, color: "amber" },
    { name: "Localizados", value: "LOCATED", tableTab: 4, color: "red" },
  ],
};
